/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { RouteProps, RouteComponentProps, Redirect } from 'react-router-dom';

import { User } from '@/models/User';

import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import PrivateRouteEnterprise from './PrivateRouteEnterprise';

interface Props extends Omit<RouteProps, 'component'> {
  component: React.ComponentType<RouteComponentProps>;
  module: 'portal' | 'enterprise';
  authenticated?: boolean;
  restricted?: boolean;
  canActivate?: (user: User | null) => boolean;
}

const ModuleRoute: React.FC<Props> = ({
  module,
  authenticated = false,
  restricted = false,
  ...rest
}: Props) => {
  const isProdEnvironment = process.env.REACT_APP_ENV === 'production';
  const isPortal = process.env.REACT_APP_PORTAL === 'true';

  if (module === 'portal' && isProdEnvironment && !isPortal) {
    return <Redirect to="/not-found" />;
  }

  if (module === 'enterprise' && isProdEnvironment && isPortal) {
    return <Redirect to="/not-found" />;
  }

  if (authenticated) {
    if (module === 'enterprise') {
      return <PrivateRouteEnterprise {...rest} />;
    }

    return <PrivateRoute {...rest} />;
  }

  return <PublicRoute restricted={restricted} {...rest} />;
};

export default ModuleRoute;
